import { isProduction } from '@config/api'
import { CacheAdapter } from '@shared/infra'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'

import { env } from '@/env'

export function HeadScripts(): React.ReactElement {
  const userData = CacheAdapter.get('userData')

  useEffect(() => {
    if (isProduction) {
      // Load zendesk script
      const zendeskScript = document.createElement('script')
      zendeskScript.id = 'ze-snippet'
      zendeskScript.src = `https://static.zdassets.com/ekr/snippet.js?key=${env.REACT_APP_ZENDESK_KEY}`
      document.body.appendChild(zendeskScript)
    }
  }, [])

  return (
    <>
      {isProduction && userData?.attributes && (
        <Helmet>
          <script type="text/javascript">
            {`
              <!-- Hotjar Tracking -->
              (function(h,o,t,j,a,r){
                  h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                  h._hjSettings={hjid:${env.REACT_APP_HOTJAR_KEY},hjsv:6};
                  a=o.getElementsByTagName('head')[0];
                  r=o.createElement('script');r.async=1;
                  r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                  a.appendChild(r);
              })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
              <!-- Hotjar Tracking -->
            `}
            {/* {`
               (function(c,l,a,r,i,t,y){
                 c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                 t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                 y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
               })(window, document, "clarity", "script", "${env.REACT_APP_MICROSOFT_CLARITY_KEY}");
               window.clarity('identify', '${userData.attributes?.email} | ${userData.attributes?.name} | ${userData.attributes?.phone_number}');
             `} */}
          </script>
        </Helmet>
      )}
    </>
  )
}
